/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Dialog } from '@coursera/cds-core';

import type { SubmissionHeader } from 'bundles/grading/api/types';
// eslint-disable-next-line import/no-cycle
import AttemptReview from 'bundles/grading/components/staff-graded-assignments/attempts/AttemptReview';
import AttemptSelector from 'bundles/grading/components/staff-graded-assignments/attempts/AttemptSelector';
import useSubmissionAttemptQuery from 'bundles/grading/hooks/useSubmissionAttemptQuery';
import { generateSubmissionAttemptQueryVariables } from 'bundles/grading/utils/apiUtils';

import _t from 'i18n!nls/grading';

const styles = {
  dialog: () => css`
    // make dialog take maximum height from start
    & .cds-Dialog-dialog {
      height: 100%;
    }
  `,
};

type Props = {
  submissionHeaders: SubmissionHeader[];
  isOpen: boolean;
  onClose: () => void;
  groupId: string;
  itemId: string;
  submitterId: string;
  gradingGroupId?: string;
};

const AttemptsDialog = ({
  submissionHeaders,
  isOpen,
  onClose,
  groupId,
  itemId,
  submitterId,
  gradingGroupId,
}: Props) => {
  const { HeadingGroup, Content } = Dialog;

  const [selectedAttemptId, setSelectedAttemptId] = React.useState<string>(submissionHeaders[0].submissionAttemptId);
  const handleAttemptIdChange = (attemptId: string) => setSelectedAttemptId(attemptId);

  const queryVariables = generateSubmissionAttemptQueryVariables(
    groupId,
    itemId,
    submitterId,
    selectedAttemptId,
    gradingGroupId
  );

  const attempt = useSubmissionAttemptQuery(queryVariables);

  return (
    <Dialog
      open={isOpen}
      variant="standard"
      width="large"
      onClose={onClose}
      css={styles.dialog}
      aria-describedby="view-all-attempts-dialog"
    >
      <HeadingGroup>{_t('View all attempts')}</HeadingGroup>

      <Content id="view-all-attempts-dialog">
        <AttemptSelector
          submissionHeaders={submissionHeaders}
          selectedAttemptId={selectedAttemptId}
          onChange={handleAttemptIdChange}
        />
        <AttemptReview loading={attempt.loading} error={attempt.error} questions={attempt.data} />
      </Content>
    </Dialog>
  );
};

export default AttemptsDialog;
